var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 48,
    viewBox: "0 0 55 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4606 47.5601C44.6667 47.5601 54.6131 37.6358 54.6131 25.4076C54.6131 13.2015 44.6667 3.25507 32.4606 3.25507C20.2324 3.25507 10.3081 13.2015 10.3081 25.4076C10.3081 37.4285 19.8989 47.223 31.8409 47.5516L32.4606 47.5601Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9136 31.3113C26.8456 31.3113 25.9815 32.1851 25.9815 33.2531C25.9815 34.321 26.8456 35.1948 27.9136 35.1948C28.9816 35.1948 29.8554 34.321 29.8554 33.2531C29.8554 32.1851 28.9816 31.3113 27.9136 31.3113ZM22.0883 15.777V17.7188H24.03L27.5253 25.0878L26.2146 27.4665C26.0592 27.7384 25.9718 28.0588 25.9718 28.3986C25.9718 29.4666 26.8456 30.3404 27.9136 30.3404H39.5643V28.3986H28.3214C28.1855 28.3986 28.0787 28.2918 28.0787 28.1559L28.1078 28.0394L28.9816 26.4568H36.2148C36.9429 26.4568 37.5837 26.0587 37.9138 25.4568L41.3896 19.1557C41.4673 19.0198 41.5061 18.8547 41.5061 18.6897C41.5061 18.1557 41.0692 17.7188 40.5352 17.7188H26.1757L25.2631 15.777H22.0883ZM37.6225 31.3113C36.5546 31.3113 35.6905 32.1851 35.6905 33.2531C35.6905 34.321 36.5546 35.1948 37.6225 35.1948C38.6905 35.1948 39.5643 34.321 39.5643 33.2531C39.5643 32.1851 38.6905 31.3113 37.6225 31.3113Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b",
    x: -2.71215,
    y: -9.76519,
    width: 70.3456,
    height: 70.3456,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 6.51013
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.0005,
    y1: 9,
    x2: 30.5005,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#902F92",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE60E0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.3ae0c7abb15d2a70d500887f71677d53.svg";
export { ForwardRef as ReactComponent };